export default {"src":"/_next/static/media/HP.e17f63fd.svg","height":18,"width":18};